import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
	chartHeading: {
		display: 'flex',
		justifyContent: 'flex-end',
		textAlign: 'center'
	},
	dropDown: {
		flexGrow: 1,
		marginLeft: '15%'
	},
	maximizeButton: {
		marginRight: 15
	}
}));
